class LWContainer extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    render() {
        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                display: block;
                /* We gebruiken CSS variabelen zodat je het thema buitenaf kunt aanpassen */
                --max-width: var(--lw-container-width, 90%);
                --padding: var(--lw-container-padding, 20px);
            }

             
            .container {
                width: 100%;
                padding: 5px 20px;
                box-sizing: border-box;
            }
            

            @media (min-width: 600px) {
            .container {
                max-width: var(--max-width);
                margin-left: auto;
                margin-right: auto;
                padding-left: var(--padding);
                padding-right: var(--padding);
                
            }

            /* Extra hulp-class voor volledige hoogte indien nodig */
            :host([full-height]) .container {
                height: 100%;
            }
        }

           

        </style>

        <div class="container">
            <slot></slot>
        </div>
        `;
    }
}

customElements.define('lw-container', LWContainer);